import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import InitialStockService from '../../services/inventory/InitialStockService';
import { setIsSubmitting, setWasRegistered, resetForm } from '../../store/slices/inventory/initialStockSlice';
import useAlerts from '../useAlerts';
import useLoading from '../useLoading';
import useApiErrorHandler from '../useApiErrorHandler';

/**
 * Hook para manejar Inventario Inicial.
 */
export const useInitialStock = () => {
    const dispatch: AppDispatch = useDispatch();
    const { form, isSubmitting, wasRegistered } = useSelector((state: RootState) => state.initialStock);

    const { show: showAlert } = useAlerts();
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const { handle } = useApiErrorHandler();

    const handlerRegisterInitialStock = async () => {
        try {
            dispatch(setIsSubmitting(true));
            showLoadingIndicator();

            // 🔥 Construimos el payload limpio
            const payload = {
                branchId: Number(form.branchId),
                productId: Number(form.productId),
                quantity: Number(form.quantity),
                unitCost: Number(form.unitCost),
            };

            const response = await InitialStockService.registerInitialStock(payload);
            const { statusCode, title, message, type } = response;

            if (statusCode === 201) {
                showAlert(type, title, message);
                dispatch(setWasRegistered(true)); // ✅ Marcar como registrado
                dispatch(resetForm());             // ✅ Resetear form
            } else {
                showAlert(type || 'error', title || 'Error', message || 'Ocurrió un error.');
            }
        } catch (error) {
            handle(error);
        } finally {
            dispatch(setIsSubmitting(false));
            hideLoadingIndicator();
        }
    };


    return {
        form,
        isSubmitting,
        wasRegistered,
        handlerRegisterInitialStock,
    };
};
